import React from "react"
import SimpleMarkdown from "simple-markdown"

export const rules = {
  Array: { ...SimpleMarkdown.defaultRules.Array },
  paragraph: {
    ...SimpleMarkdown.defaultRules.paragraph,
    react: function (node: any, output: any, state: any) {
      return SimpleMarkdown.reactElement("span", state.key, {
        className: "",
        children: output(node.content, state)
      })
    }
  },
  text: { ...SimpleMarkdown.defaultRules.text },
  sup: {
    ...SimpleMarkdown.defaultRules.u,
    match: SimpleMarkdown.inlineRegex(/^\^((?:\\[\s\S]|[^\\])+?)\^/),
    react: function (node: any, output: any, state: any) {
      return SimpleMarkdown.reactElement("sup", state.key, {
        children: output(node.content, state)
      })
    }
  },
  sub: {
    ...SimpleMarkdown.defaultRules.u,
    react: function (node: any, output: any, state: any) {
      return SimpleMarkdown.reactElement("sub", state.key, {
        children: output(node.content, state)
      })
    }
  },
  em: {
    ...SimpleMarkdown.defaultRules.em,
    match: SimpleMarkdown.inlineRegex(/^\_((?:\\[\s\S]|[^\\])+?)\_/)
  },
  strong: {
    ...SimpleMarkdown.defaultRules.strong,
    match: SimpleMarkdown.inlineRegex(/^\*((?:\\[\s\S]|[^\\])+?)\*/)
  },
  escape: { ...SimpleMarkdown.defaultRules.escape }
}

const rawBuiltParser = SimpleMarkdown.parserFor(rules)
const parse = function (source: string) {
  var blockSource = source + "\n\n"
  return rawBuiltParser(blockSource, { inline: false })
}

const reactOutput = SimpleMarkdown.outputFor(rules, "react")

export function MDtoHTML(text: string) {
  return SimpleMarkdown.outputFor(rules, "html")(parse(text))
}
interface Props {
  text: string
}

const EscapeText: React.FC<Props> = (props: Props) => {
  const { text } = props

  return reactOutput(parse(text))
}

export default EscapeText
